import { CellIcon } from './CellIcon';

class FixedCellIcon extends CellIcon {

}

export {
  FixedCellIcon,
};
